export default {
  name: "XcpGameLog",
  computed: {
    key: function key() {
      //  return this.$route.fullPath;
      return this.$route.fullPath;
    }
  }
};